module.exports = __webpack_public_path__ + "img/heading_no.a28ef83f.svg";